import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "x-t-cell-spin-editor x-cell-editor"
};
const _hoisted_2 = {
  key: 1,
  class: "x-cell-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  return $props.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass({
      'inner-border': true,
      'input-error': $props.error
    })
  }, [_createVNode(_component_a_input, {
    bordered: $setup.isFocused,
    value: $setup.formData,
    onBlur: $setup.handleBLur,
    onFocus: $setup.handleFocus,
    style: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      padding: '1px 5px'
    },
    "onUpdate:value": $setup.handleUpdateValue,
    onKeypress: _withKeys($setup.handleKeyPress, ["native"]),
    onInput: $setup.handleInput
  }, {
    prefix: _withCtx(() => [_renderSlot(_ctx.$slots, "prefix", {}, () => [_createElementVNode("a", {
      href: "javascript:void(0)",
      class: "btn-sub",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleSubtract && $setup.handleSubtract(...args))
    }, "-")])]),
    suffix: _withCtx(() => [_renderSlot(_ctx.$slots, "suffix", {}, () => [_createElementVNode("a", {
      href: "javascript:void(0)",
      class: "btn-plus",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.handlePlus && $setup.handlePlus(...args))
    }, "+")])]),
    _: 3
  }, 8, ["bordered", "value", "onBlur", "onFocus", "onUpdate:value", "onKeypress", "onInput"])], 2)])) : (_openBlock(), _createElementBlock("span", _hoisted_2, [_createElementVNode("span", {
    class: _normalizeClass({
      'input-error': !!$props.error
    })
  }, _toDisplayString($props.value), 3)]));
}